module.exports = __webpack_public_path__ + "img/404.b55143a8.svg";